import React from 'react'

function DownloadBtn() {
  return (
    <div className='sticky-download-btn'><a href="https://tindersingapore.onelink.me/NK8P/schoolofswipe" target={"_blank"} rel={"noreferrer"}>Download <span style={{ marginLeft: '0.2rem' }}>Tinder</span></a></div>
  )
}

export default DownloadBtn;